import { useServices } from "@core/servicesContext";
import { AsyncResult, PaginatedDataResult, useMappedStore, useStoredData } from "@utils/hooks";
import { Profile } from "@domain/user/profile";
import { Livecourse } from "./livecourse";

export function useGroupLivecourse(shareroomId: string): PaginatedDataResult<Livecourse> {
	const { livecourseService } = useServices();
	return useMappedStore(shareroomId, livecourseService.userLivecoursesStore, [shareroomId]);
}

export function useOrganizationLivecourse(organizationId: string): PaginatedDataResult<Livecourse> {
	const { livecourseService } = useServices();
	return useMappedStore(organizationId, livecourseService.organizationLivecoursesStore, [organizationId]);
}

export function getLivecourseInfos(livecourseId: string): AsyncResult<Livecourse> {
	const { livecourseService } = useServices();
	return useStoredData(livecourseId, livecourseService.getInfos, [livecourseId]);
}

export function confirmParticipation(livecourseId: string): AsyncResult<Livecourse> {
	const { livecourseService } = useServices();
	return useStoredData(livecourseId, livecourseService.confirmParticipation, [livecourseId]);
}

export function useParticipants(id: string): PaginatedDataResult<Profile> {
	const { livecourseService } = useServices();
	return useMappedStore(id, livecourseService.participantsStore, [id]);
}
